import { default as api } from '../services/api';

const boundingBoxApi = {
  /**
   * Get all bounding boxes with optional filtering
   * @param {Object} options - Optional parameters
   * @param {number} options.photo_id - Filter by photo ID
   * @param {number} options.defect_type_id - Filter by defect type ID
   * @param {string} options.status - Filter by status
   * @returns {Promise} - Promise with response
   */
  getAll: async (options = {}) => {
    try {
      const queryParams = new URLSearchParams();
      
      // Add all options to query parameters
      Object.entries(options).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          queryParams.append(key, value);
        }
      });
      
      const response = await api.get(`/bounding-boxes${queryParams.toString() ? `?${queryParams.toString()}` : ''}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching bounding boxes:', error);
      throw error;
    }
  },

  /**
   * Get bounding box by ID
   * @param {number} id - Bounding box ID
   * @returns {Promise} - Promise with response
   */
  getById: async (id) => {
    try {
      const response = await api.get(`/bounding-boxes/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching bounding box with ID ${id}:`, error);
      throw error;
    }
  },

  /**
   * Create new bounding box
   * @param {Object} boundingBoxData - Bounding box data
   * @returns {Promise} - Promise with response
   */
  create: async (boundingBoxData) => {
    try {
      const response = await api.post(`/bounding-boxes`, boundingBoxData);
      return response.data;
    } catch (error) {
      console.error('Error creating bounding box:', error);
      throw error;
    }
  },

  /**
   * Update bounding box
   * @param {number} id - Bounding box ID
   * @param {Object} boundingBoxData - Updated bounding box data
   * @returns {Promise} - Promise with response
   */
  update: async (id, boundingBoxData) => {
    try {
      const response = await api.put(`/bounding-boxes/${id}`, boundingBoxData);
      return response.data;
    } catch (error) {
      console.error(`Error updating bounding box with ID ${id}:`, error);
      throw error;
    }
  },

  /**
   * Group multiple bounding boxes
   * @param {Array} boundingBoxIds - Array of bounding box IDs to group
   * @returns {Promise} - Promise with response
   */
  groupBoxes: async (boundingBoxIds) => {
    try {
      const response = await api.post(`/bounding-boxes/group`, {
        bounding_box_ids: boundingBoxIds
      });
      return response.data;
    } catch (error) {
      console.error('Error grouping bounding boxes:', error);
      throw error;
    }
  },

  /**
   * Delete bounding box by ID
   * @param {number} id - Bounding box ID
   * @returns {Promise} - Promise with response
   */
  delete: async (id) => {
    try {
      const response = await api.delete(`/bounding-boxes/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting bounding box with ID ${id}:`, error);
      throw error;
    }
  }
};

export default boundingBoxApi; 